import { Component, EventEmitter, ViewChild } from '@angular/core';
import { DataSourceGrid } from '../../../utils/data-source-grid.component';
import { DataService } from '../../../utils/data.service';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import { generalService } from '../../../services/general.service';
import * as moment from 'moment';
import { agregarSalidaComponent } from '../agregar/agregarSalida.component';
import { config } from 'process';

@Component ({
  selector: 'historialSalida-component',
  styles: [],
  templateUrl: 'historialSalida.component.html',
  providers: [generalService]
})

export class historialSalidaComponent {
  constructor(private _generalService: generalService, 
              public dialog: MatDialog, 
              public dataService: DataService) {
    this.historialSalidas = new Array();
    this.dataService.guardado = false;     
    this.dataService.tipo = "";     
    this.filtros = {
      idSucursal: this.idSucursal,
      rangoInicio: this.dateRange.startDate.format('YYYY-MM-DD'),
      rangoFinal: this.dateRange.endDate.format('YYYY-MM-DD') };
  }
  
  dataSalidas: DataSourceGrid | null;
  displayedColumns = ['columnaI', 'columnaII', 'columnaIII', 'columnaIV', 'columnaV', 'columnaVI'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  locale: {
    format: 'DD-MM-YYYY', 
    separator: ' - ',
    firstDay: 1 };
  ranges: any = {
    'Hoy': [moment(), moment()],
    'Mes actual': [moment().startOf('month'), moment().endOf('month')],
    'Ultimos 2 meses': [moment().subtract(2, 'month').startOf('month'), moment(), moment()] };
  
  public dateRange: any = {
    startDate: moment().startOf('month'),
    endDate: moment()   };
  public historialSalidas: Array<any>;
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public idSucursal:number = this.userData.ORGANIZATION_ID;
  public filtros: any;

  ngOnInit() {
    this.salidasGetTable()
  }

  ngModelChange(valor){ 
    this.filtros.rangoInicio = valor.startDate.format('YYYY-MM-DD');
    this.filtros.rangoFinal = valor.endDate.format('YYYY-MM-DD');
    this.salidasGetTable(); 
  }

  salidasGetTable() {
    let tipo = 'agregar';
    let string = "SalidaAlmacen/salidasGetTable";

    this._generalService
      .metodoCallParamsPutPost(tipo, this.filtros, string)
        .subscribe(result => {
          this.historialSalidas = JSON.parse(result);
          this.dataSalidas = new DataSourceGrid(this.historialSalidas, this.paginator, this.sort);
          console.log(this.historialSalidas);
          if(this.historialSalidas.length <= 0)
            { $(".mat-row").remove(".mat-row"); }
        }, error => 
          {  console.log(<any>error);  }
    );
  }

  salidasGoToEdit(idSalida){
    this.dataService.tipo = "editar";
    this.dataService.id = idSalida;
    const dialogRef = this.dialog.open(agregarSalidaComponent, {disableClose: true, 
      width:'100%', maxWidth:'70%', panelClass: 'full-width-dialog', height:'100%', maxHeight:'90%'});
    this.dataService.dialogRef = dialogRef; 
    dialogRef.afterClosed().subscribe((result) => {
      this.salidasGetTable();  
      this._generalService.toastCall("La salida se modificó exitosamente!");
      this.dataService.tipo = "";
    });
  }

  salidasDelete(salida) {
    const eliminarHttp = new EventEmitter();
    eliminarHttp.subscribe((ok) => {
      this._generalService.toastCall(ok.message);
      this.salidasGetTable();
    });
    this._generalService.modal(eliminarHttp,
                               'confirm',
                               `¿Desea eliminar la salida #${salida.noSalida}?`,
                               'EntradaAlmacen/entradaDelete',
                               salida.idSalida);
  }

  entradasGoToEdit(idSalida){
    this.dataService.tipo = "editar";
    this.dataService.id = idSalida;
    const dialogRef = this.dialog.open(agregarSalidaComponent, {disableClose: true, 
      width:'100%', maxWidth:'70%', panelClass: 'full-width-dialog', height:'100%', maxHeight:'90%'});
    this.dataService.dialogRef = dialogRef; 
    dialogRef.afterClosed().subscribe((result) => {
      this.salidasGetTable();  
      this.dataService.tipo = "";
    });
  }

  salidasReadOnly(idSalida){
    this.dataService.tipo = "ver";
    this.dataService.id = idSalida;
    const dialogRef = this.dialog.open(agregarSalidaComponent, {disableClose: true, 
      width:'100%', maxWidth:'70%', panelClass: 'full-width-dialog', height:'100%', maxHeight:'90%'});
    this.dataService.dialogRef = dialogRef; 
    dialogRef.afterClosed().subscribe((result) => {
      this.salidasGetTable();  
      this.dataService.tipo = "";
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/almacen/salidas/historial/historialSalida.component.ts